import React, { memo } from 'react'
import { Box } from '@mui/material'
import MultiStrikeChartSkeletonPlaceholder from './MultiStrikeChartSkeletonPlaceholder'
import MultiStrikeMetadataSkeletonPlaceholder from './MultiStrikeMetadataSkeletonPlaceholder'

const OVERLAY_SX = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 5,
    pointerEvents: 'none',
} as const

const METADATA_OVERLAY_SX = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 6,
    pointerEvents: 'none',
} as const

type Props = {
    showMetadata?: boolean
}

const MultiStrikeChartSkeletonOverlay: React.FC<Props> = ({ showMetadata = true }) => (
    <>
        <Box sx={OVERLAY_SX}>
            <MultiStrikeChartSkeletonPlaceholder />
        </Box>
        {showMetadata ? (
            <Box sx={METADATA_OVERLAY_SX}>
                <MultiStrikeMetadataSkeletonPlaceholder />
            </Box>
        ) : null}
    </>
)

export default memo(MultiStrikeChartSkeletonOverlay)
